import { KeyValue } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AFRegistrationDomain } from '../model/af.model';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-create-vendor-profile',
  templateUrl: './create-vendor-profile.component.html',
  styleUrls: ['./create-vendor-profile.component.scss']
})
export class CreateVendorProfileComponent implements OnInit, AfterViewInit {

  user: AFRegistrationDomain;
  showPasswordHint: boolean = false;
  showReEnterPasswordHint: boolean = false;
  hide: boolean = true;
  showError: boolean = false;
  readMessage: boolean = false;
  accountGroup: UntypedFormGroup;

  valueAscOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return a.value.localeCompare(b.value);
  }

  constructor(private router: Router, private fb: UntypedFormBuilder, private userService: AuthService, private route: ActivatedRoute,) {
  }
  get password() { return this.accountGroup.get('passwordGroup').get('password') }
  get reenterPassword() { return this.accountGroup.get('passwordGroup').get('reenterPassword') }
  get question1() { return this.accountGroup.get('securityQuestions').get('question1') }
  get question2() { return this.accountGroup.get('securityQuestions').get('question2') }
  get question3() { return this.accountGroup.get('securityQuestions').get('question3') }
  get question4() { return this.accountGroup.get('securityQuestions').get('question4') }
  get question5() { return this.accountGroup.get('securityQuestions').get('question5') }
  get answer1() { return this.accountGroup.get('securityQuestions').get('answer1') }
  get answer2() { return this.accountGroup.get('securityQuestions').get('answer2') }
  get answer3() { return this.accountGroup.get('securityQuestions').get('answer3') }
  get answer4() { return this.accountGroup.get('securityQuestions').get('answer4') }
  get answer5() { return this.accountGroup.get('securityQuestions').get('answer5') }
  get securityQuestions() { return this.accountGroup.get('securityQuestions') }

  ngOnInit() {
    this.createGroup();
    this.user = this.userService.getVendorUser();
  }


  ngAfterViewInit() {
    this.securityQuestions.valueChanges.subscribe(() => {
      this.questionValidation(this.securityQuestions);
    });
  }

  createGroup() {
    this.accountGroup = this.fb.group({
      //userName: [''],
      passwordGroup: this.fb.group({
        password: ['', [Validators.required, Validators.minLength(8), Validators.pattern('(?:[0-9]+[a-z A-Z]|[a-z A-Z]+[0-9])[a-z A-Z 0-9]*')]],
        reenterPassword: ['', [Validators.required]],
        check1: [{ value: '', disabled: true }],
        check2: [{ value: '', disabled: true }],
        check3: [{ value: '', disabled: true }],
        check4: [{ value: '', disabled: true }],
        check5: [{ value: '', disabled: true }],
        check6: [{ value: '', disabled: true }]
      }, { validators: passwordMatchValidator() }),

      securityQuestions: this.fb.group({
        question1: ['', [Validators.required]],
        question2: ['', Validators.required],
        question3: ['', Validators.required],
        question4: ['', Validators.required],
        question5: ['', Validators.required],
        answer1: ['', Validators.required],
        answer2: ['', Validators.required],
        answer3: ['', Validators.required],
        answer4: ['', Validators.required],
        answer5: ['', Validators.required]
      })
    });
  }

  questionValidation(control: AbstractControl) {
    const question1Control = control.get('question1');
    const question2Control = control.get('question2');
    const question3Control = control.get('question3');
    const question4Control = control.get('question4');
    const question5Control = control.get('question5');

    let questionArray = [
      question1Control,
      question2Control,
      question3Control,
      question4Control,
      question5Control
    ];

    for (let container of questionArray) {
      if (!container.hasError("required")) {
        container.setErrors(null);
      }
    }

    let duplicateQuestions = questionArray.filter(i => questionArray.filter(ii => (ii.value != null) && (i.value != null) && (ii.value.key === i.value.key)).length > 1);

    for (let container of duplicateQuestions) {
      container.setErrors({ duplicate: true });
    }

    const answer1Control = control.get('answer1');
    const answer2Control = control.get('answer2');
    const answer3Control = control.get('answer3');
    const answer4Control = control.get('answer4');
    const answer5Control = control.get('answer5');

    let answerArray = [
      answer1Control,
      answer2Control,
      answer3Control,
      answer4Control,
      answer5Control
    ];
    for (let container of answerArray) {
      if (!container.hasError("required")) {
        container.setErrors(null);
      }
    }

    let duplicateAnswers = answerArray.filter(i => answerArray.filter(ii => (ii.value != "") && (ii.value === i.value)).length > 1);

    for (let container of duplicateAnswers) {
      container.setErrors({ duplicate: true });
    }
  }

  showHintTwo() {
    this.showReEnterPasswordHint = !this.showReEnterPasswordHint;
  }

  onSubmit() {
    let registrationDomain = new AFRegistrationDomain();
    registrationDomain.verifyId = this.userService.getVerifyId();

    if (registrationDomain.verifyId) {
      registrationDomain.username = this.user.username;
      registrationDomain.password = this.password.value;
      registrationDomain.question1 = this.question1.value.key;
      registrationDomain.question2 = this.question2.value.key;
      registrationDomain.question3 = this.question3.value.key;
      registrationDomain.question4 = this.question4.value.key;
      registrationDomain.question5 = this.question5.value.key;

      registrationDomain.answer1 = this.answer1.value;
      registrationDomain.answer2 = this.answer2.value;
      registrationDomain.answer3 = this.answer3.value;
      registrationDomain.answer4 = this.answer4.value;
      registrationDomain.answer5 = this.answer5.value;

      this.userService.createVendorProfile(registrationDomain).subscribe({
        next: (data) => {
          if (data.errorMessage === "Password does not match requirements.") {
            this.user.errorMessage = data.errorMessage;
            this.showError = true;
          } else {
            this.router.navigate(['successProfile']);
          }
        },
        error: (error: any) => console.log(error)
      });
    }
  }

  generatePassword() {
    let i: number;
    let randPass: string;
    let loop: boolean = false;
    let values: Uint32Array;
    const charSet: string = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    const keywords = /(APPL|ASDF|BASIC|CADAM|DEMO|FOCUS|GAME|IBM|LOG|NATION|NCNB|NET|NEW|MONEY|RESET|ROS|SIGN|SOVRAN|SYS|TEST|TSO|VALID|VTAM|XXX|1234|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)/i;

    do {
      randPass = "";
      values = new Uint32Array(8);
      window.crypto.getRandomValues(values);

      for (i = 0; i < 8; ++i) {
        randPass += charSet[values[i] % charSet.length];
      }

      if (randPass.match(/^(?=.*[a-zA-Z])(?=.*[0-9])/) && !randPass.match(keywords)) {
        this.password.setValue(randPass);
        loop = false;
      } else {
        loop = true;
      }
    } while (loop);
  }

  showHint() {
    this.showPasswordHint = !this.showPasswordHint;
    this.showError = false;
  }

  invalidAlert() {
    // For screen reader
    if (!this.accountGroup.valid) {
      this.readMessage = true;
    }
  }

  clearAlert() {
    // For screen reader
    this.readMessage = false;
  }

  checkSpecialCharacters(str: string) {
    const regex = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
    return !regex.test(str);
  }
  checkAlphaCharacter(str: string) {
    const regex = /[a-zA-Z]/;
    return regex.test(str);
  }
  checkNumeric(str: string) {
    const regex = /[0-9]/;
    return regex.test(str);
  }
}

export function passwordMatchValidator(): ValidatorFn {
  return (control: UntypedFormGroup): ValidationErrors | null => {
    const errors: ValidationErrors = {};
    const password = control.get('password');
    const passwordConfirm = control.get('reenterPassword');

    /* confrim password validation */
    if (password.value && passwordConfirm.value && (password.value != passwordConfirm.value)) {
      passwordConfirm.setErrors({ noMatch: true });
    }
    return Object.keys(errors).length ? errors : null;
  };
}




